export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Final (2)_04.53221942.jpg";